import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "parsed_main_content": {
      "column": null,
      "name": "parsed_main_content",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "new",
        "name": "state",
        "null": true,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "survey_step_element_id": {
      "column": {
        "default": null,
        "name": "survey_step_element_id",
        "null": false,
        "type": null
      },
      "name": "survey_step_element_id",
      "selected_by_default": null,
      "translated": null
    },
    "team_survey_step_id": {
      "column": {
        "default": null,
        "name": "team_survey_step_id",
        "null": false,
        "type": null
      },
      "name": "team_survey_step_id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "parsed_content": {
      "column": null,
      "name": "parsed_content",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "TeamSurveyStepElement",
  "collectionKey": "team_survey_step_elements",
  "collectionName": "team_survey_step_elements",
  "i18nKey": "team_survey_step_element",
  "camelizedLower": "teamSurveyStepElement",
  "name": "TeamSurveyStepElement",
  "nameDasherized": "team-survey-step-element",
  "pluralName": "team_survey_step_elements",
  "ransackable_associations": [
    {
      "className": "TeamSurveyStepElementAnswer",
      "collectionName": "team_survey_step_element_answers",
      "foreignKey": "team_survey_step_element_id",
      "name": "answers",
      "macro": "has_many",
      "resource_name": "TeamSurveyStepElementAnswer",
      "through": null
    },
    {
      "className": "TeamSurveyStepElement::Audit",
      "collectionName": "team_survey_step_element_audits",
      "foreignKey": "team_survey_step_element_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "TeamSurveyStepElementAudit",
      "through": null
    },
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_step",
      "macro": "has_one",
      "resource_name": "ClassStep",
      "through": "school_class"
    },
    {
      "className": "TeamSurveyStepElement::Audit",
      "collectionName": "team_survey_step_element_audits",
      "foreignKey": "team_survey_step_element_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "TeamSurveyStepElementAudit",
      "through": null
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "contact_id",
      "name": "school",
      "macro": "has_one",
      "resource_name": "School",
      "through": "school_class"
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_class",
      "macro": "has_one",
      "resource_name": "SchoolClass",
      "through": "team"
    },
    {
      "className": "SurveyStep",
      "collectionName": "survey_steps",
      "foreignKey": "survey_step_id",
      "name": "survey_step",
      "macro": "has_one",
      "resource_name": "SurveyStep",
      "through": "team_survey_step"
    },
    {
      "className": "SurveyStepElement",
      "collectionName": "survey_step_elements",
      "foreignKey": "survey_step_element_id",
      "name": "survey_step_element",
      "macro": "belongs_to",
      "resource_name": "SurveyStepElement",
      "through": null
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "team",
      "macro": "has_one",
      "resource_name": "Team",
      "through": "team_survey"
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_survey_id",
      "name": "team_survey",
      "macro": "has_one",
      "resource_name": "TeamSurvey",
      "through": "team_survey_step"
    },
    {
      "className": "TeamSurveyStep",
      "collectionName": "team_survey_steps",
      "foreignKey": "team_survey_step_id",
      "name": "team_survey_step",
      "macro": "belongs_to",
      "resource_name": "TeamSurveyStep",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "state",
      "column": {
        "default": "new",
        "name": "state",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "survey_step_element_id",
      "column": {
        "default": null,
        "name": "survey_step_element_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "team_survey_step_id",
      "column": {
        "default": null,
        "name": "team_survey_step_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "TeamSurveyStepElementAnswer",
      "collectionName": "team_survey_step_element_answers",
      "foreignKey": "team_survey_step_element_id",
      "name": "answers",
      "macro": "has_many",
      "resource_name": "TeamSurveyStepElementAnswer",
      "through": null
    },
    {
      "className": "SurveyStepElement",
      "collectionName": "survey_step_elements",
      "foreignKey": "survey_step_element_id",
      "name": "survey_step_element",
      "macro": "belongs_to",
      "resource_name": "SurveyStepElement",
      "through": null
    },
    {
      "className": "TeamSurveyStep",
      "collectionName": "team_survey_steps",
      "foreignKey": "team_survey_step_id",
      "name": "team_survey_step",
      "macro": "belongs_to",
      "resource_name": "TeamSurveyStep",
      "through": null
    }
  ],
  "paramKey": "team_survey_step_element",
  "primaryKey": "id"
}

/** Frontend model for TeamSurveyStepElement. */
class TeamSurveyStepElement extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  parsedMainContent() {
    return this.readAttributeUnderscore("parsed_main_content")
  }

  /** @returns {boolean} */
  hasParsedMainContent() {
    const value = this.parsedMainContent()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {any} */
  surveyStepElementId() {
    return this.readAttributeUnderscore("survey_step_element_id")
  }

  /** @returns {boolean} */
  hasSurveyStepElementId() {
    const value = this.surveyStepElementId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  teamSurveyStepId() {
    return this.readAttributeUnderscore("team_survey_step_id")
  }

  /** @returns {boolean} */
  hasTeamSurveyStepId() {
    const value = this.teamSurveyStepId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  parsedContent() {
    return this.readAttributeUnderscore("parsed_content")
  }

  /** @returns {boolean} */
  hasParsedContent() {
    const value = this.parsedContent()

    return this._isPresent(value)
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./team-survey-step-element-answer.js").default>} */
  answers() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TeamSurveyStepElementAnswer")

    const ransack = {}

    ransack["team_survey_step_element_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "answers",
        model: this,
        modelName: "TeamSurveyStepElementAnswer",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./team-survey-step-element-answer.js").default>>} */
  loadAnswers() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("TeamSurveyStepElementAnswer")

    const ransack = {}

    ransack["team_survey_step_element_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "answers",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("./survey-step-element.js").default | null} */
  surveyStepElement() {
    return this._readBelongsToReflection({reflectionName: "survey_step_element"})
  }

  /** @returns {Promise<import("./survey-step-element.js").default | null>} */
  loadSurveyStepElement() {
    if (!("surveyStepElementId" in this)) throw new Error("Foreign key method wasn't defined: surveyStepElementId")

    const id = this.surveyStepElementId()
    const modelClass = modelClassRequire("SurveyStepElement")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "survey_step_element", model: this, modelClass},
      {ransack}
    )
  }

  /** @returns {import("./team-survey-step.js").default | null} */
  teamSurveyStep() {
    return this._readBelongsToReflection({reflectionName: "team_survey_step"})
  }

  /** @returns {Promise<import("./team-survey-step.js").default | null>} */
  loadTeamSurveyStep() {
    if (!("teamSurveyStepId" in this)) throw new Error("Foreign key method wasn't defined: teamSurveyStepId")

    const id = this.teamSurveyStepId()
    const modelClass = modelClassRequire("TeamSurveyStep")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "team_survey_step", model: this, modelClass},
      {ransack}
    )
  }
}

export default TeamSurveyStepElement
